import { render, staticRenderFns } from "./Tab3.vue?vue&type=template&id=03d1d8aa&"
import script from "./Tab3.vue?vue&type=script&lang=ts&"
export * from "./Tab3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports